import { Masonry } from '@leagueplatform/masonry';
import { MASONRY } from 'common/constants';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useIntl } from '@leagueplatform/locales';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { MasonryPageLayout } from 'components/masonry-page-layout/masonry-page-layout.component';
import { useQueryParams } from '@leagueplatform/routing';

export const VirtualConsultationPage = () => {
  usePageViewAnalytics({ screen_name: 'Book Virtual Consultation' });
  const { formatMessage } = useIntl();
  const params = useQueryParams();
  useDocumentTitle(formatMessage({ id: 'STR_BOOK_VIRTUAL_CONSULTATION' }));

  return (
    <MasonryPageLayout showBackButton>
      <Masonry
        rootNodeId={MASONRY.ROOT_NODE_VIRTUAL_CONSULTATION_PAGE}
        initialQueryParams={Object.fromEntries(params)}
      />
    </MasonryPageLayout>
  );
};
